import { render, staticRenderFns } from "./mq-indicator.vue?vue&type=template&id=0acdd3d4"
import script from "./mq-indicator.vue?vue&type=script&lang=ts"
export * from "./mq-indicator.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./mq-indicator.vue?vue&type=style&index=0&id=0acdd3d4&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports